import { SessionManager } from '../model/session/SessionManager';
export const SessionService = new SessionManager();
